import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'pp-media-thumbnail',
  templateUrl: './media-thumbnail.component.html',
  imports: [CommonModule],
})
export class MediaThumbnailComponent {

  readonly alt = input<string>();
  readonly id = input<string>();
  readonly inheritSize = input(false);
  readonly mediaThumbnailUri = input<string>();
  readonly size = input<number>();

  /**
   * The thumbnail width in pixels.
   * @readonly
   * @type {string | null}
   * @memberof MediaThumbnailComponent
   */
  get width(): string | null {
    const size = this.size();
    if (size) return `${size}px`;
    return null;
  }
}
